import "../styles/index.css";
import TelegramMiniApp from "./modules/telegram-app/telegram-mini-app";

export function App() {
  return (
    <TelegramMiniApp />
  );
}

export default App;
